/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useCallback } from 'react';

import {
  FaSort,
  FaSortDown,
  FaSortUp,
  FaThumbsDown,
  FaThumbsUp,
  FaEquals,
  FaEnvelope,
  FaEye,
} from 'react-icons/fa';
import { FaX } from 'react-icons/fa6';
import { Content, MessageModal, MessagePreview } from './styles';
import TableContainer from '../TableContainer';

const SimpleTable = ({ tbody, thead, click, reSend }) => {
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState('');
  const [messagePreview, setMessagePreview] = useState('');
  const [showPreview, setShowPreview] = useState(false);
  const [previewPosition, setPreviewPosition] = useState({ x: 0, y: 0 });

  const handleViewMessage = useCallback(message => {
    setSelectedMessage(message);
    setShowMessageModal(true);
  }, []);

  const handleMouseEnter = useCallback((e, message) => {
    const rect = e.target.getBoundingClientRect();
    setPreviewPosition({
      x: rect.left - 250, // Position to the left of the eye icon
      y: rect.top - 10,
    });
    setMessagePreview(message);
    setShowPreview(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setShowPreview(false);
    setMessagePreview('');
  }, []);

  return (
    <Content>
      <TableContainer>
        <thead>
          <tr>
            {thead.map((item, index) => (
              <th
                key={index}
                id={item.id}
                className={item.className}
                onClick={() => (item.sort ? click(index) : undefined)}
              >
                {`${item.title} `}
                {item.sort === 'desc' ? (
                  <FaSortDown />
                ) : item.sort === 'asc' ? (
                  <FaSortUp />
                ) : item.sort === 'na' ? (
                  <FaSort />
                ) : (
                  ''
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tbody.map((item, index) => (
            <tr key={index} className="hover">
              <td className="situation">
                {item.situation === 1 ? (
                  <>
                    <FaThumbsUp color="#006229" />
                    <span style={{ marginLeft: '5px', color: '#006229' }}>
                      Enviado
                    </span>
                  </>
                ) : item.situation === 0 ? (
                  <>
                    <FaEquals color="#485365" />
                    <span style={{ marginLeft: '5px', color: '#485365' }}>
                      Em espera
                    </span>
                  </>
                ) : (
                  <>
                    <FaThumbsDown color="#E53935" />
                    <span style={{ marginLeft: '5px', color: '#E53935' }}>
                      Não enviado
                    </span>
                  </>
                )}
              </td>
              <td className="date">{item.date}</td>
              <td className="hour">{item.hour}</td>
              <td className="resend">
                {item.interactive}
                <FaEnvelope
                  color={
                    item.situation === 1
                      ? '#485365'
                      : item.situation === 0
                      ? '#01579B'
                      : '#006229'
                  }
                  onClick={() => {
                    if (item.situation !== 1 && item.situation !== 0) {
                      reSend(index);
                    }
                  }}
                  data-tip="Enviar"
                  data-for="option"
                />
              </td>
              <td className="date">{item.send_message}</td>
              <td className="hour">{item.send_hour}</td>
              <td className="sender">
                {item.sender?.nick || item.sender?.name || ''}
              </td>
              <td className="cliente">
                {item.client?.nickname || item.client?.name || ''}
              </td>
              <td className="resiver">
                {item.resiver?.nickname || item.resiver?.name || ''}
              </td>
              <td className="phone">
                {item.resiver?.contacts[0]
                  ? item.resiver?.contacts[0].content
                  : ''}
              </td>
              <td className="message">
                <div className="message-container">
                  <span className="message-text">
                    {item.message && item.message.length > 50
                      ? `${item.message.substring(0, 50)}...`
                      : item.message}
                  </span>
                  <FaEye
                    className="eye-icon"
                    color="#44546a"
                    size={14}
                    onClick={() => handleViewMessage(item.message)}
                    onMouseEnter={e => handleMouseEnter(e, item.message)}
                    onMouseLeave={handleMouseLeave}
                    data-tip="Ver mensagem completa"
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </TableContainer>

      {showPreview && messagePreview && (
        <MessagePreview
          style={{ left: previewPosition.x, top: previewPosition.y }}
        >
          <div className="preview-content">{messagePreview}</div>
        </MessagePreview>
      )}

      {showMessageModal && (
        // eslint-disable-next-line react/jsx-no-comment-textnodes
        <MessageModal onClick={() => setShowMessageModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Mensagem Completa</h3>
              <FaX onClick={() => setShowMessageModal(false)} />
            </div>
            <div className="modal-body">
              <div className="whatsapp-message">{selectedMessage}</div>
            </div>
          </div>
        </MessageModal>
      )}
    </Content>
  );
};

export default SimpleTable;
